import React from 'react'
import { Radio, useTheme } from '@mui/material'
import { More } from 'iconsax-react'

import ButtonMenu from '../ButtonMenu'

import { useEnterMode } from '@SonarCX/providers/EnterModeProvider'
import useStyles from './styles'

const NORMAL_SEND = 'true'
const SHIFT_SEND = 'false'
const ENTER_OPTIONS = {
  [NORMAL_SEND]: ['Press Enter to Send', 'Pressing Enter will send message'],
  [SHIFT_SEND]: ['Click Send', 'Clicking Send will send message']
}

const SendControl: React.FC = () => {
  const theme = useTheme()

  const { sendOnEnter, setSendOnEnter } = useEnterMode()

  const classes = useStyles()

  const renderOption = React.useCallback(
    (id: string) => {
      const [title, subtitle] = ENTER_OPTIONS[id]

      return (
        <div className={classes.option}>
          <div className='radio'>
            <Radio
              checked={`${sendOnEnter}` === id}
              color='primary'
              size='small'
            />
          </div>

          <div className='title'>
            <div>{title}</div>

            <div>{subtitle}</div>
          </div>
        </div>
      )
    },
    [classes.option, sendOnEnter]
  )

  return (
    // @ts-ignore
    <ButtonMenu
      options={Object.keys(ENTER_OPTIONS)}
      onSelect={setSendOnEnter}
      selected={`${sendOnEnter}`}
      renderFunc={renderOption}
      origin={{
        anchor: { vertical: 'top', horizontal: 'right' },
        transform: { vertical: 'bottom', horizontal: 'right' }
      }}
      className={classes.root}
    >
      <More size={theme.size.base} className={classes.btn} />
    </ButtonMenu>
  )
}

export default SendControl
